import { render } from "./AddressModel.vue?vue&type=template&id=3b6f0fec&scoped=true"
import script from "./AddressModel.vue?vue&type=script&lang=js"
export * from "./AddressModel.vue?vue&type=script&lang=js"

import "./AddressModel.vue?vue&type=style&index=0&id=3b6f0fec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6f0fec"]])

export default __exports__